module.exports = __webpack_public_path__ + "static/media/04.e754e056.wav";